import React from 'react'
import {ProjectPreviewList, NoResult, LogoSpinner, Button} from 'shared'

export const ProjectList = (props) => {
  return <div className='row'>
    {props.projects.map((project, index) =>
      <div className="col-md-8 m-b" key={index}>
        {props.render(project, index)}
      </div>
    )}

    {props.projects.length == 0 && (props.isLoading ? <ProjectPreviewList count={props.perPage} /> : <NoResult />)}

    {props.loadNextPage && <div className='col-md-24 text-center'>

      {!props.loadButton && props.isLoading && <LogoSpinner color='#9ECB0A' />}
      {!props.loadButton && !props.isLoading && <button className='simulated-link' onClick={props.loadNextPage}>{I18n.t('discover.categories.index.moar')}</button>}

      {props.loadButton && <Button className='btn-large' smallSpinner loading={props.isLoading} onClick={props.loadNextPage}>{I18n.t('discover.categories.index.moar')}</Button>}

    </div>}
  </div>
}
